module dg.files {

    class FileAccess {
        resourceUrl?: string;
        token?: string;
    }

    export class BlobStorageService {

        private blobAccessUrlExpirationDate: Date;
        private fileAccess: FileAccess = new FileAccess();

        public constructor(
            private restfullApiService: dg.restfulApi.RestfullApiClientService,
            private $q: ng.IQService,
            private $http: ng.IHttpService) {
        }

        public getBlobContainerAccessUrl(): ng.IPromise<FileAccess> {
            let deferred = this.$q.defer();
            if (this.fileAccess && this.fileAccess.resourceUrl && (this.blobAccessUrlExpirationDate > new Date())) {
                deferred.resolve(this.fileAccess);
            }
            else {
                this.restfullApiService.get(`/files/token`).then((result: any) => {

                    this.fileAccess.resourceUrl = result.data.value.resourceUrl;

                    this.fileAccess.token = result.data.value.token;

                    this.blobAccessUrlExpirationDate = new Date(result.data.value.expirationDate);

                    deferred.resolve(this.fileAccess);
                }, deferred.reject);
            }

            return deferred.promise;
        }
        
        public commitBlockList = (apiUrl: string, fileType: string, blockNames: any) => {
            let uri = apiUrl + '&comp=blocklist';

            var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
            for (var i = 0; i < blockNames.length; i++) {
                requestBody += '<Uncommitted>' + blockNames[i] + '</Uncommitted>';
            }
            requestBody += '</BlockList>';

            return this.$http({
                url: uri,
                method: 'PUT',
                data: requestBody,
                headers: {
                    "Content-Type": "application/xml",
                    "x-ms-blob-content-type": fileType
                }
            });
        }

        public generateBlockBlobUrl = (apiUrl: string, blockNames: Array<string>) => {
            //the length of the block ids should be the same
            let blockId = 'block-' + (<any>blockNames.length.toString()).padEnd(6);

            blockNames.push(window.btoa(blockId));
            let uri = apiUrl + '&comp=block&blockid=' + blockNames[blockNames.length - 1];
            return uri;
        }

        public replaceUrlPlaceholders(url: string, placeholderParams: any): string {
            for (let key in placeholderParams) {
                if (url.indexOf(`{${key}}`) > -1) {
                    if (placeholderParams[key].constructor === Array) {
                        url = url.replace(`{${key}}`, placeholderParams[key][0]);
                    }
                    else {
                        url = url.replace(`{${key}}`, placeholderParams[key]);
                    }
                }
            }

            return url;
        }

        public buildUrl(resourceUrl: string, container: string, token: string): string {
            return resourceUrl + '/' + container + token;
        }
    }

    angular.module('dg.files')
        .service('blobStorageService', ["restfullApiClientService", "$q", "$http", BlobStorageService]);
}
